import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/auth/Auth';
import { useUser } from 'context/user/User';
import paths from 'routes/paths';
import { enterProducerPanel } from './enterProducerPanel';

/**
 * O que acontece depois que o link do e-mail aceita o convite. Sem login, leva
 * para a tela de entrar e o login devolve para `/eventos` com os mesmos
 * parâmetros do convite (é o `redirectTo` do SignIn). Já conectado, abre direto
 * o painel do produtor que fez o convite, com as permissões que ele liberou.
 *
 * `redirecting` avisa quem usa o hook para não mostrar o modal enquanto a
 * página está de saída; sem acesso ao painel o modal segue como antes.
 *
 * @param {{ active: boolean, producerId: string|null, inviteParams: URLSearchParams }} options
 */
export default function useAcceptedInviteRedirect({ active, producerId, inviteParams }) {
    const navigate = useNavigate();
    const { isAuth } = useAuth();
    const { user, getUser } = useUser();

    const access = (user?.producer_panel_access || []).find(
        (item) => String(item.producer_id) === String(producerId)
    );

    useEffect(() => {
        if (!active) return;

        if (!isAuth) {
            const search = new URLSearchParams({ redirectTo: paths.events.home });
            inviteParams.forEach((value, key) => search.set(key, value));

            navigate(`${paths.login}?${search.toString()}`, { replace: true });
            return;
        }

        if (!user) {
            getUser();
            return;
        }

        if (access) enterProducerPanel(access);
    }, [active, isAuth, user]);

    return { access, redirecting: active && (!isAuth || !!access) };
}
